import { client } from '../lib/client';

// 공지 — 첫 방문 팝업 모달·상단 배너 (서버 quinors_web_notices)
export const noticeAPI = () => (
  client({
    url: '/v1/notice',
  })
);
